import * as React from 'react';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import clsx from 'clsx';
import { CommonPropsAndTypes } from '../../_Types/StandardComponentProps';
import EDTooltip from '../../Tooltip/EDTooltip';
// FIXME: Fixa idiotmerge

interface IProps extends CommonPropsAndTypes.IPaddingProps {
  onClick?: (event: React.MouseEvent<any>) => void;
  onMouseDown?: (event: React.MouseEvent<any>) => void;
  children?: React.ReactNode;
  style?: any;
  dense?: boolean;
  divider?: boolean;
  testId?: string;
  className?: string;
  disableGutters?: boolean;
  disableTabbing?: boolean; // Får tabIndex -1 så att tab hoppar över komponenten
  disabled?: boolean;
  disabledReason?: string;
  disableRipple?: boolean;
  selected?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {},
  gutters: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(3),
  },
  noGutters: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  noVertPadding: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  noLeftPadding: {
    paddingLeft: theme.spacing(0),
  },
  noTopPadding: {
    paddingTop: theme.spacing(0),
  },
  minimalVerticalPadding: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  button: {},
  focusVisible: {},
  disabled: {},
});

/**
 Komponent för items i en List.

 Se exempel för List.
 */
const EDListItem = React.forwardRef<HTMLLIElement, IProps>(
  (props: IProps, ref) => {
    const {
      children,
      disableVerticalPadding,
      minimalPadding,
      classes,
      testId,
      disableTabbing,
      leftPadding,
      topPadding,
      selected,
      disabledReason,
      ...rest
    } = props;

    const tabIndex = disableTabbing ? -1 : 0;
    // button prop is typed as 'true' rather than boolean. Hopefully fixed in future versions
    return (
      <EDTooltip
        title={rest.disabled ? disabledReason : undefined}
        enableClickOnTouch={rest.disabled}
      >
        <span>
          <MuiListItem
            {...rest}
            ref={ref}
            tabIndex={tabIndex}
            classes={{
              root: clsx(classes.root, {
                [classes.noVertPadding]: disableVerticalPadding,
                [classes.minimalVerticalPadding]: minimalPadding,
                [classes.noLeftPadding]: leftPadding === 'none',
                [classes.noTopPadding]: topPadding === 'none',
              }),
              gutters: !props.disableGutters
                ? classes.gutters
                : classes.noGutters,
            }}
            data-testid={testId}
          >
            {children}
          </MuiListItem>
        </span>
      </EDTooltip>
    );
  }
);

export const EDListItemButton = withStyles(
  React.forwardRef<HTMLDivElement, IProps>((props: IProps, ref) => {
    const {
      children,
      disableVerticalPadding,
      minimalPadding,
      classes,
      testId,
      disableTabbing,
      leftPadding,
      topPadding,
      selected,
      disabledReason,
      ...rest
    } = props;

    const tabIndex = disableTabbing ? -1 : 0;
    // button prop is typed as 'true' rather than boolean. Hopefully fixed in future versions
    return (
      <EDTooltip
        title={rest.disabled ? disabledReason : undefined}
        enableClickOnTouch={rest.disabled}
      >
        <span>
          <MuiListItemButton
            {...rest}
            ref={ref}
            tabIndex={tabIndex}
            classes={{
              root: clsx(classes.root, {
                [classes.noVertPadding]: disableVerticalPadding,
                [classes.minimalVerticalPadding]: minimalPadding,
                [classes.noLeftPadding]: leftPadding === 'none',
                [classes.noTopPadding]: topPadding === 'none',
              }),
              gutters: !props.disableGutters
                ? classes.gutters
                : classes.noGutters,
              focusVisible: classes.focusVisible,
              disabled: classes.disabled,
            }}
            data-testid={testId}
            selected={selected}
          >
            {children}
          </MuiListItemButton>
        </span>
      </EDTooltip>
    );
  }),
  styles
);

export default withStyles(EDListItem, styles);
